import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

const AddNoticeForm = (props) => {

    const { schools } = useContext(SchoolContex)

    const [data, setData] = useState({
        notice: '',
        school: '',
        link: '',
    })
    const [file, setFile] = useState();


    const [load, setLoad] = useState(false);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        setFile(e.target.files[0]);
    }

    const saveNotice = () => {
        setLoad(true)
        const postData = new FormData();
        if (props.modalData?.id) {
            postData.append('id', props.modalData.id)
        }
        postData.append('notice', data.notice)
        postData.append('school', data.school)
        postData.append('link', data.link)
        postData.append('file', file)

        axios.post(`${process.env.REACT_APP_MAIN_API}saveNotice`, postData)
            .then((res) => {
                // console.log(res);
                props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

            })
            .catch((err) => {
                // console.log(err.response);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    useEffect(() => {
        setData(props.modalData)
        // console.log(props.modalData,'props.modalData notice');
    },[props])


    return (
        <>
            <div className='row'>

                <div className='col-md-12 p-2'>
                    <label htmlFor="">Notice</label>
                    <input type="text" className='form-control' name="notice" value={data.notice} onChange={handleInput} id="" />
                </div>

                <div className='col-md-3 p-2'>
                    <label htmlFor="">Related School:</label>

                    <select className='form-control' name='school' value={data.school} onChange={handleInput}>
                        <option>--selest--</option>
                        {schools && schools.map((sch)=>
                        (
                            <option value={sch.schoolName}>{sch.schoolName}</option>
                        ))}
                        <option value='All'>All</option>
                    </select>

                </div>


                <div className='col-md-3 p-2'>
                    <label htmlFor="">Notice File:</label>
                    <input type="file" className='form-control' name="image" onChange={handleImg} id="" />

                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Notice Link:</label>
                    <input type="text" className='form-control' name="link" onChange={handleInput} id="" value={data.link}/>
                </div>

                
                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={saveNotice}>Save Notice</Button>
                </div>



            </div>
        </>
    )
}

export default AddNoticeForm;